<!-- <div class="news__list__item " *ngIf="event">
  <div class="news-img bg-blue">
    <a [routerLink]="['/events/seminars', event.id]" style="text-decoration: none;">
      <img src="{{event?.flatData?.coverImage[0]?.url}}" alt="News" />
    </a>
  </div>
  <div class="news-caption" style=" ">
    <span class="news-title font-bold my-3">{{ event?.flatData?.conferenceTitle || event?.flatData?.courseTitle ||
      event?.flatData?.seminarTitle }}</span>

    <div style="border-top: 1px dashed rgb(190, 190, 190); width: 80%;">


    </div>
    <span class="news-date my-3">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_3021_4897)">
          <path
            d="M13.9375 1.25H12.5V0.5C12.5 0.223875 12.2762 0 12 0C11.7238 0 11.5 0.223875 11.5 0.5V1.25H4.5V0.5C4.5 0.223875 4.27616 0 4 0C3.72384 0 3.5 0.223875 3.5 0.5V1.25H2.0625C0.925219 1.25 0 2.17522 0 3.3125V13.9375C0 15.0748 0.925219 16 2.0625 16H13.9375C15.0748 16 16 15.0748 16 13.9375V3.3125C16 2.17522 15.0748 1.25 13.9375 1.25ZM15 13.9375C15 14.5243 14.5243 15 13.9375 15H2.0625C1.47569 15 1 14.5243 1 13.9375V5.65625C1 5.56997 1.06997 5.5 1.15625 5.5H14.8438C14.93 5.5 15 5.56997 15 5.65625V13.9375Z"
            fill="#121212" />
        </g>
        <defs>
          <clipPath id="clip0_3021_4897">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>

      <span *ngIf="event?.flatData?.startDate != null"> من :{{event?.flatData?.startDate| date}}</span>
      <span *ngIf="event?.flatData?.endDate != null"> الي :{{event?.flatData?.endDate| date}}</span>


    </span>
  </div>
</div> -->


<div class="news__list__item " *ngIf="exhibition">
  <div class="news-img bg-blue">
    <a [routerLink]="['/events/exhibitions', exhibition.id]" style="text-decoration: none;">
      <img src="{{exhibition?.flatData?.coverImage[0]?.url}}" alt="News" />
    </a>
  </div>
  <div class="news-caption">
    <span class="news-title font-bold my-3">{{ exhibition?.flatData?.conferenceTitle }}</span>
    <div style="border-top: 1px dashed rgb(190, 190, 190); width: 80%;">
    </div>
    <span class="news-date my-3">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_3021_4897)">
          <path
            d="M13.9375 1.25H12.5V0.5C12.5 0.223875 12.2762 0 12 0C11.7238 0 11.5 0.223875 11.5 0.5V1.25H4.5V0.5C4.5 0.223875 4.27616 0 4 0C3.72384 0 3.5 0.223875 3.5 0.5V1.25H2.0625C0.925219 1.25 0 2.17522 0 3.3125V13.9375C0 15.0748 0.925219 16 2.0625 16H13.9375C15.0748 16 16 15.0748 16 13.9375V3.3125C16 2.17522 15.0748 1.25 13.9375 1.25ZM15 13.9375C15 14.5243 14.5243 15 13.9375 15H2.0625C1.47569 15 1 14.5243 1 13.9375V5.65625C1 5.56997 1.06997 5.5 1.15625 5.5H14.8438C14.93 5.5 15 5.56997 15 5.65625V13.9375Z"
            fill="#121212" />
        </g>
        <defs>
          <clipPath id="clip0_3021_4897">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>

      <span *ngIf="exhibition?.flatData?.startDate != null"> من :{{exhibition?.flatData?.startDate| date}}</span>
      <span *ngIf="exhibition?.flatData?.endDate != null"> الي :{{exhibition?.flatData?.endDate| date}}</span>


    </span>
  </div>
</div>

<div class="news__list__item " *ngIf="seminar">
  <div class="news-img bg-blue">
    <a [routerLink]="['/events/seminars', seminar.id]" style="text-decoration: none;">
      <img src="{{seminar?.flatData?.coverImage[0]?.url}}" alt="News" />
    </a>
  </div>
  <div class="news-caption">
    <span class="news-title font-bold my-3">{{ seminar?.flatData?.courseTitle }}</span>
    <div style="border-top: 1px dashed rgb(190, 190, 190); width: 80%;">
    </div>
    <span class="news-date my-3">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_3021_4897)">
          <path
            d="M13.9375 1.25H12.5V0.5C12.5 0.223875 12.2762 0 12 0C11.7238 0 11.5 0.223875 11.5 0.5V1.25H4.5V0.5C4.5 0.223875 4.27616 0 4 0C3.72384 0 3.5 0.223875 3.5 0.5V1.25H2.0625C0.925219 1.25 0 2.17522 0 3.3125V13.9375C0 15.0748 0.925219 16 2.0625 16H13.9375C15.0748 16 16 15.0748 16 13.9375V3.3125C16 2.17522 15.0748 1.25 13.9375 1.25ZM15 13.9375C15 14.5243 14.5243 15 13.9375 15H2.0625C1.47569 15 1 14.5243 1 13.9375V5.65625C1 5.56997 1.06997 5.5 1.15625 5.5H14.8438C14.93 5.5 15 5.56997 15 5.65625V13.9375Z"
            fill="#121212" />
        </g>
        <defs>
          <clipPath id="clip0_3021_4897">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>

      <span *ngIf="seminar?.flatData?.startDate != null"> من :{{seminar?.flatData?.startDate| date}}</span>
      <span *ngIf="seminar?.flatData?.endDate != null"> الي :{{seminar?.flatData?.endDate| date}}</span>


    </span>
  </div>
</div>

<div class="news__list__item " *ngIf="lecture">
  <div class="news-img bg-blue">
    <a [routerLink]="['/events/lectures', lecture.id]" style="text-decoration: none;">
      <img src="{{lecture?.flatData?.coverImage[0]?.url}}" alt="News" />
    </a>
  </div>
  <div class="news-caption">
    <span class="news-title font-bold my-3">{{ lecture?.flatData?.seminarTitle }}</span>
    <div style="border-top: 1px dashed rgb(190, 190, 190); width: 80%;">
    </div>
    <span class="news-date my-3">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_3021_4897)">
          <path
            d="M13.9375 1.25H12.5V0.5C12.5 0.223875 12.2762 0 12 0C11.7238 0 11.5 0.223875 11.5 0.5V1.25H4.5V0.5C4.5 0.223875 4.27616 0 4 0C3.72384 0 3.5 0.223875 3.5 0.5V1.25H2.0625C0.925219 1.25 0 2.17522 0 3.3125V13.9375C0 15.0748 0.925219 16 2.0625 16H13.9375C15.0748 16 16 15.0748 16 13.9375V3.3125C16 2.17522 15.0748 1.25 13.9375 1.25ZM15 13.9375C15 14.5243 14.5243 15 13.9375 15H2.0625C1.47569 15 1 14.5243 1 13.9375V5.65625C1 5.56997 1.06997 5.5 1.15625 5.5H14.8438C14.93 5.5 15 5.56997 15 5.65625V13.9375Z"
            fill="#121212" />
        </g>
        <defs>
          <clipPath id="clip0_3021_4897">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>

      <span *ngIf="lecture?.flatData?.startDate != null"> من :{{lecture?.flatData?.startDate| date}}</span>
      <span *ngIf="lecture?.flatData?.endDate != null"> الي :{{lecture?.flatData?.endDate| date}}</span>


    </span>
  </div>
</div>